export enum Environment {
    DEVELOPMENT = 'local',
    ACCEPTANCE = 'acceptance',
    PRODUCTION = 'production',
    UNKNOWN = 'client-env-unknown',
}
